module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// ./~/aphrodite/no-important.js
// module id = 201
// module chunks = 3 4 6 7 10 12 15 18 19 20 21 22